import React, { useContext } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { CartContext } from "../Tienda/components/ParadigmaCartProvider/ParadigmaCartProvider";
import functions from "../Tienda/functions/functions";
import { GlobalConfigTienda } from "../TiendaConfig";
import "./ProductoBox.scss";

const PromoIcon = ({ text }) => {
  const colorPercentBased = () => "#e5620d";
  return (
    <svg width="72" height="32" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id="shadow">
          <feDropShadow
            dx="3"
            dy="3"
            stdDeviation="2"
            flood-color="#f6a32c"
            flood-opacity="0.5"
          ></feDropShadow>
        </filter>
      </defs>
      <g style={{ filter: "url(#shadow)" }}>
        <path
          d="M0,0 L72,0 L63,14 L72,28 L0,28 Z"
          fill={colorPercentBased()}
        ></path>
        <text
          x="43%"
          y="50%"
          fill="white"
          dominant-baseline="middle"
          text-anchor="middle"
        >
          PROMO
        </text>
      </g>
    </svg>
  );
};

const OffIcon = ({ percent }) => {
  const colorPercentBased = (percent) => {
    const red = "#e52233";
    const softOrange = "#f6a32c";
    const darkOrange = "#e5620d";
    return percent >= 25 ? red : percent > 15 ? darkOrange : softOrange;
  };
  return (
    <svg width="40" height="60" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id="shadow">
          <feDropShadow
            dx="3"
            dy="3"
            stdDeviation="2"
            flood-color={colorPercentBased(percent)}
            flood-opacity="0.5"
          ></feDropShadow>
        </filter>
      </defs>
      <g style={{ filter: "url(#shadow)" }}>
        <path
          d="M40,0 L0,0 L0,60 L20,45 L40,60 L40,0z"
          fill={colorPercentBased(percent)}
        ></path>
        <text
          x="50%"
          y="20%"
          fill="white"
          dominant-baseline="middle"
          text-anchor="middle"
        >
          {percent}%
        </text>
        <text
          x="50%"
          y="50%"
          fill="white"
          dominant-baseline="middle"
          text-anchor="middle"
        >
          OFF
        </text>
      </g>
    </svg>
  );
};

const getPrecio = (articulo, ofertaPeriodo, ofertaCantidad, superoferta) => {
  let price = articulo.Precio;
  switch (true) {
    case ofertaPeriodo && !superoferta:
      price = articulo.Precio;
      break;
    case ofertaCantidad && !superoferta:
      price = articulo.OfertaNxM_Precio;
      break;
    case !ofertaPeriodo && !ofertaCantidad && superoferta:
      price = articulo.PrecioSuperOferta;
      break;
    default:
      price = articulo.Precio;
  }
  price = price * (1 + articulo.MargenRentabilidad / 100);
  return functions.FormatPrice(price, GlobalConfigTienda.NumeroDecimales);
};

const ProductoBoxView = (props) => {
  const { link, image, title, oldPrice, price, descuento } = props;

  const history = useHistory();

  return (
    <>
      <div className="productItem">
        {descuento > 0 && (
          <div className="productItem__off productItem__off--orange productItem__off--Promo">
            <PromoIcon text="Promo" />
            {/* <OffIcon percent={descuento} /> */}
          </div>
        )}
        <Link to={link} className="productItem__photoContainer">
          <img src={image.src} alt="" className="productItem__photo" />
        </Link>
        <div className="productItem__price">
          {oldPrice && descuento > 0 ? (
            <>
              {oldPrice && <del className="priceOld">${oldPrice}</del>}
              <h3 className={"mb-0 price " + (oldPrice && "price__offer")}>
                ${price}
              </h3>
            </>
          ) : (
            <h3 className={"mb-0 price mx-auto"}>
              {price !== "Consultar" ? `$ ${price}` : price}
            </h3>
          )}
        </div>
        <h2 className="productItem__title" onClick={() => history.push(link)}>
          {title}
        </h2>
        {/* <button onClick={() => history.push(link)} className="btn btn-success btn-productobox">
          Ver producto <i className="fa fa-arrow-circle-right" aria-hidden="true"></i>
        </button> */}
      </div>
    </>
  );
};

const ProductoBox = ({ articulo }) => {
  const { setItem, getCantidadItem, isItemPresent } = useContext(CartContext);

  const ofertaPeriodo =
    articulo.OfertaPeriodo_FechaDesde != null &&
    articulo.OfertaPeriodo_FechaHasta != null &&
    Date.parse(articulo.OfertaPeriodo_FechaHasta) >= Date.now();
  const ofertaCantidad = articulo.OfertaNxM_Cantidad > 0;
  const superoferta = articulo.DescuentoSuperOferta > 0;

  const addCart = () => {
    let cantItem = isItemPresent({
      code: articulo.code,
      talle_id: null,
      color_id: null,
    })
      ? getCantidadItem({ code: articulo.code, talle_id: null, color_id: null })
      : 0;
    setItem({
      code: articulo.code,
      talle_id: null,
      color_id: null,
      quantity: cantItem + 1,
    });
  };

  // Categorias a ocultar precios -- Ahora son Todos los Electrodomesticos
  // let catOcultarPrecio = [131, 132, 133, 134, 135, 136];

  // let sinPrecio = null;
  // if (catOcultarPrecio.includes(articulo.Categoria.Padre_id)) {
  //   sinPrecio = "Consultar";
  // }

  return (
    <ProductoBoxView
      link={"/tienda/producto/" + articulo.code}
      image={articulo.Imagenes[0]}
      category={
        articulo.Rubro && articulo.Rubro.Nombre
          ? articulo.Rubro.Nombre
          : "Sin Rubro"
      }
      title={articulo.Titulo}
      oldPrice={
        ofertaPeriodo || ofertaCantidad || superoferta
          ? getPrecio(articulo, false, false, false)
          : null
      }
      price={getPrecio(articulo, ofertaPeriodo, ofertaCantidad, superoferta)}
      addCart={addCart}
      descuento={articulo.DescuentoSuperOferta}
    />
  );
};

export default ProductoBox;
